import { render, staticRenderFns } from "./StyleCategoryMethodology.vue?vue&type=template&id=45e49e28&"
import script from "./StyleCategoryMethodology.vue?vue&type=script&lang=js&"
export * from "./StyleCategoryMethodology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports